import React from 'react';

import { styled } from '@mui/material/styles';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';

import FacebookIcon from '~/assets/icons/FacebookIcon';
import LinkedInIcon from '~/assets/icons/LinkedInIcon';
import TwitterIcon from '~/assets/icons/TwitterIcon';
import { SUBMIDDLE_MARGIN_PX } from '~/theme';

export const SocialShare = ({ title }) => {
  const currentLocation = window?.location?.href || '';

  return (
    <ShareButtons onClick={(e) => e.stopPropagation()}>
      <LinkedinShareButton title={title} url={currentLocation} resetButtonStyle={true}>
        <ShareIconWrapper>
          <LinkedInIcon color={'#7384c3'} />
        </ShareIconWrapper>
      </LinkedinShareButton>
      <TwitterShareButton title={title} url={currentLocation} resetButtonStyle={true}>
        <ShareIconWrapper>
          <TwitterIcon color={'#7384c3'} />
        </ShareIconWrapper>
      </TwitterShareButton>
      <FacebookShareButton quote={title} url={currentLocation} resetButtonStyle={true}>
        <ShareIconWrapper>
          <FacebookIcon color={'#7384c3'} />
        </ShareIconWrapper>
      </FacebookShareButton>
    </ShareButtons>
  );
};

const ShareButtons = styled('div')`
  display: flex;
  justify-content: center;
  gap: ${SUBMIDDLE_MARGIN_PX};

  & .react-share__ShareButton {
    outline: none;

    & svg {
      width: 16px;
      height: auto;

      & path {
        fill: ${({ theme }) => theme.palette.common.white};
      }
    }

    &:hover svg path {
      fill: ${({ theme }) => theme.palette.common.violet};
    }
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    text-align: left;
    margin-left: auto;
  }
`;
const ShareIconWrapper = styled('div')`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.common.blackSecondary};
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
